export enum PromoPackType {
    ActiePrijs = "ACTIEPRIJS",
    CombinatiePrijs = "COMBINATIE_PRIJS",
    ExtraBonuspunten = "EXTRA_BONUSPUNTEN",
    GratisArtikel = "GRATIS_ARTIKEL",
    KortingBedrag = "KORTING_BEDRAG",
    KortingProcent = "KORTING_PROCENT",
    DocumentKorting = "DOCUMENT_KORTING",
    KortingProcentUitz = "KORTING_PROCENT_UITZ",
    FolderPrijs = "FOLDERPRIJS",
    OutletPrijs = "OUTLETPRIJS",
    Cashback = "CASHBACK",
    GratisTransportKost = "GRATIS_TRANSPORTKOST",
    Nieuw = "NIEUW",
    Zbon = "ZBON",
    Zbop = "ZBOP"
}
